import { NgModule } from '@angular/core';

import { RastreamentosComponent } from "./rastreamentos.component";
import {SharedModule} from "../shared/shared.module";
import {RastreamentoMenuComponent} from "./shared/rastreamento-menu/rastreamento-menu.component";
import {RastreamentoConfiguracaoComponent} from "./configuracao/rastreamento-configuracao.component";
import {RastreamentoMapaComponent} from "./rastreamento-mapa/rastreamento-mapa.component";
import {RastreamentoMapa2Component} from "./rastreamento-mapa2/rastreamento-mapa2.component";
import {RastreamentoVeiculosComponent} from "./rastreamento-veiculos/rastreamento-veiculos.component";
import {RastreamentoService} from "./shared/rastreamento.service";
import {RastreamentosRoutingModule} from "./rastreamentos-routing.module";
import {RastreamentoApiService} from "./shared/rastreamento-api.service";
import {RastreamentoHistoricoComponent} from "./rastreamento-historico/rastreamento-historico.component";
import {ModeloGpsModule} from "./modelos-gps/modelos-gps.module";
import {CercaModule} from "./cercas/cercas.module";
import {AlarmeModule} from "./alarmes/alarmes.module";
import {TemplatesModule} from "./templates/templates.module";

@NgModule({
    imports: [
        SharedModule,
        ModeloGpsModule,
        CercaModule,
        AlarmeModule,
        TemplatesModule,
        RastreamentosRoutingModule
    ],
    providers: [
        RastreamentoService,
        RastreamentoApiService
    ],
    declarations: [
        RastreamentosComponent,
        RastreamentoMenuComponent,
        RastreamentoConfiguracaoComponent,
        RastreamentoMapaComponent,
        RastreamentoMapa2Component,
        RastreamentoVeiculosComponent,
        RastreamentoHistoricoComponent
    ],
    exports: [
        RastreamentoMenuComponent,
    ]
})
export class RastreamentosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/rastreamentos.module.ts
 **/